// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var MM_api = require("./MM_api.res.js");
var Core__JSON = require("@rescript/core/src/Core__JSON.res.js");

function updateSettingsApi(setMarkFirstProvableStepAsGoal, markFirstProvableStepAsGoal) {
  MM_api.setSettingsApi({
        setMarkFirstProvableStepAsGoal: MM_api.makeApiFunc("settings.setMarkFirstProvableStepAsGoal", (function (params) {
                var bool = Core__JSON.Decode.bool(MM_api.apiInputToJson(params));
                if (bool !== undefined) {
                  return setMarkFirstProvableStepAsGoal(bool);
                } else {
                  return Promise.resolve({
                              TAG: "Error",
                              _0: "The parameter of setMarkFirstProvableStepAsGoal() must be a boolean."
                            });
                }
              })),
        getMarkFirstProvableStepAsGoal: MM_api.makeApiFunc("settings.getMarkFirstProvableStepAsGoal", (function (param) {
                return Promise.resolve({
                            TAG: "Ok",
                            _0: markFirstProvableStepAsGoal
                          });
              }))
      });
}

exports.updateSettingsApi = updateSettingsApi;
/* MM_api Not a pure module */
